import React, { Component } from "react";
import TwoColumns from "../TwoColumns/TwoColumns";
import Button from "../Button/Button";
import Input from "../Input/Input";
import "./VideoItem.css";
import {
	stateOptions,
	socialIssueOptions,
	categoryOptions
} from "../../config";


class VideoItem extends Component {
	state = {
		title: this.props.video.title || "",
		state: this.props.video.state || "",
		issue: this.props.video.issue || "",
		file: this.props.video.file || "",
		thumbnail: this.props.video.thumbnail || "",
		shortlisted: this.props.video.shortlisted || "",
		category: this.props.video.category || "",
		name: this.props.video.name || "",
		reference: this.props.video.reference || ""
	};

	componentWillReceiveProps(nextProps) {
		// The video object can receive updates from outside, so lets update the state if the props change
		if (this.props.video.title !== nextProps.video.title) {
			this.setState({
				title: nextProps.video.title || "",
				state: nextProps.video.state || "",
				issue: nextProps.video.issue || "",
				file: nextProps.video.file || "",
				thumbnail: nextProps.video.thumbnail || "",
				shortlisted: nextProps.video.shortlisted || "",
				category: nextProps.video.category || "",
				name: nextProps.video.name || "",
				reference: nextProps.video.reference || ""
			});
		}
		if (this.props.video.thumbnail !== nextProps.video.thumbnail) {
			this.setState({
				thumbnail: nextProps.video.thumbnail || ""
			});
		}
	}
	handleInputEvent = (e, key) => {
		this.setState({
			[key]: e.target.value
		});
	};
	handleCheckboxEvent = (e, key) => {
		this.setState({
			[key]: this.state[key] === "on" ? "" : "on"
		});
	};
	handleUpdate = () => {
		const {
			title,
			state,
			issue,
			file,
			thumbnail,
			category,
			shortlisted,
			name,
			reference
		} = this.state;

		if(!file || !category || !issue) {
			alert("Videos must have a video file, cateogry and issue selected.");
			return;
		}

		this.props.handleUpdate({
			title,
			state,
			issue,
			file,
			thumbnail,
			category,
			shortlisted,
			name,
			reference
		});
	};
	render() {
		if (this.props.expanded) {
			const {
				title,
				state,
				issue,
				file,
				thumbnail,
				shortlisted,
				category,
				name,
				reference
			} = this.state;
			return (
				<div className="video-item">
				<div className="heading">{this.props.video.title}</div>
				<TwoColumns
				left={
					<div>
					<Input
					title="Video Title"
					value={title}
					onChange={e => this.handleInputEvent(e, "title")}
					/>
					<Input
					title="School/Individual Name"
					value={name}
					onChange={e => this.handleInputEvent(e, "name")}
					/>
					<Input
					title="State"
					value={state}
					type="dropdown"
					options={{
						"": "Select One",
						...stateOptions
					}}
					onChange={e => this.handleInputEvent(e, "state")}
					/>
					<Input
					title="Social Issue"
					value={issue}
					type="dropdown"
					options={{
						"": "Select One",
						...socialIssueOptions
					}}
					onChange={e => this.handleInputEvent(e, "issue")}
					/>
					<Input
					title="Category"
					value={category}
					type="dropdown"
					options={{
						"": "Select One",
						...categoryOptions
					}}
					onChange={e => this.handleInputEvent(e, "category")}
					/>
					<Input
					title="Include in shortlist for voting"
					value={shortlisted}
					type="checkbox"
					onChange={e => this.handleCheckboxEvent(e, "shortlisted")}
					/>
					</div>
				}
				right={
					<div>
					{this.props.video.entryId && <div><label>Original Video File</label>
					<strong>{this.props.video.entryId.split(/[-]+/).pop()}</strong></div>}
					<Input
					title="Video File"
					value={file}
					onChange={e => this.handleInputEvent(e, "file")}
					/>
					<Input
					title="Video Thumbnail"
					type="file"
					value={thumbnail}
					onComplete={filename => this.props.handleFileUpload(filename)}
					filePath={`thumbnails/${this.props.id}/`}
					/>
					{this.props.video.publicThumbnail && (
						<img
						src={this.props.video.publicThumbnail}
						alt=""
						className="thumbnail"
						/>
					)}
					<Input
					title="Box.net reference"
					value={reference}
					onChange={e => this.handleInputEvent(e, "reference")}
					/>
					</div>
				}
				/>
				<Button onClick={this.handleUpdate}>Save</Button>
				</div>
			);
		}
		return (
			<div className="video-item">
			<div className="title">
			<h3>{this.props.video.title}</h3>
			</div>
			<div className="action">
			
			{this.state.shortlisted && <span className="tag -secondary">Shortlist</span>}
			<a href="/" onClick={this.props.setExpanded}>
			Edit
			</a>{" "}
			<a href="/" onClick={this.props.removeSelf}>
			Remove
			</a>
			</div>
			</div>
		);
	}
}

export default VideoItem;



// WEBPACK FOOTER //
// ./src/components/VideoItem/VideoItem.js